import React from 'react';
import { Route, BrowserRouter as Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { ThemeProvider as SCThemeProvider } from 'styled-components';
import { StylesProvider } from '@material-ui/core/styles';
// import ScriptTag from 'react-script-tag';
import { createTheme, MuiThemeProvider } from '@material-ui/core';
import { ptBR } from '@material-ui/core/locale';

import Layout from './Layout';
import '../src/assets/styles/Template.css';

const history = createBrowserHistory();

const theme = createTheme(
  {
    palette: {
      type: 'light',
      primary: {
        main: '#FF460A',
        variant: '#E2360E',
      },
      secondary: {
        main: '#232323',
        variant: '#111111',
        grey: '#e0e0e0',
      },
    },
    typography: {
      fontFamily: ['IBM Plex Sans', 'sans-serif'].join(','),
    },
  },
  ptBR,
);

const Template = () => {
  return (
    <SCThemeProvider theme={theme}>
      {/* <ScriptTag type="text/javascript" src="https://intranetelggdev.manserv.com.br/intranetelggdev/load.js" /> */}
      <MuiThemeProvider theme={theme}>
        <StylesProvider injectFirst>
          <Router history={history}>
            <Route path="/" component={Layout} />
          </Router>
        </StylesProvider>
      </MuiThemeProvider>
    </SCThemeProvider>
  );
};

export default Template;
